/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const apiAccountsAiApiKeyUpdateBodyAnthropicApiKeyMin = 16;

export const ApiAccountsAiApiKeyUpdateBody = zod.strictObject({
    anthropic_api_key: zod
        .string()
        .min(apiAccountsAiApiKeyUpdateBodyAnthropicApiKeyMin)
        .describe('Anthropic API key used by the Form AI'),
});

export type ApiAccountsAiApiKeyUpdateBody = zod.input<
    typeof ApiAccountsAiApiKeyUpdateBody
>;
export type ApiAccountsAiApiKeyUpdateBodyOutput = zod.output<
    typeof ApiAccountsAiApiKeyUpdateBody
>;
